import { CloseIcon } from 'assets/icons/CloseIcon'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { ISelectValue } from 'constants/globalTypes'
import { createIngredient, editIngredient } from 'features/food/foodSlice'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import useModalClose from 'hooks/useModalClose'

export const IngredientsModal = ({ closeModal, value }: { closeModal: any, value?: IIngredientsModal }) => {
    const [state, setState] = useState<IIngredientsModal>(value || { name: '', unit: null })
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {
        const resp = await dispatch(value?.id ? editIngredient(state) : createIngredient(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => setState(prev => ({ ...prev, name: e.target.value }))
    const onSelect = (unit: ISelectValue) => setState(prev => ({ ...prev, unit }))

    return <Modal black>
        <Flex column between center >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Ingredient</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input labelText='Ingredient name' placeholder='Milk, sugar, salt...' value={state.name} onChange={onChange} nomarg invalid={!state.name} />
                <HonestSelectAsyncInput
                    link='units'
                    name='unit'
                    labelText='Unit'
                    placeholder='g, kg, ml...'
                    defaultValue={state?.unit?.label}
                    onChange={onSelect}
                    invalid={!state.unit}
                    parserFunction={(data: any) => data.map((i: any) => ({ label: i.name, value: i.id }))}
                />
            </Flex>
            <Button disabled={!state.name || !state?.unit?.value} orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface IIngredientsModal {
    id?: number
    name: string
    unit: ISelectValue
}